import { Component, OnInit ,ElementRef,ViewChild, AfterViewInit} from '@angular/core';
import { Router, Event, NavigationEnd} from '@angular/router';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';

@Component({
    selector: 'app-mobile-top-bar',
    templateUrl: './mobile-top-bar.component.html',
    styleUrls: ['./mobile-top-bar.component.scss'],
    standalone: false
})
export class MobileTopBarComponent implements OnInit,AfterViewInit {
  @ViewChild('focus1') myInputt: ElementRef;
  currentRoute: string = 'Contact';
  routeNo: number = 1;
  ariaText: string = '';
  constructor(private router: Router, protected $gaService: GoogleAnalyticsService) { }

  ngAfterViewInit() {
    setTimeout(() => this.myInputt.nativeElement.focus());
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        var url =event.url;
        this.enableFocusHeader(url);
      }});
    
   

 }

  ngOnInit() {

    var device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
        //  this.currentRoute = event.url.replace('/', '').replace('-', ' ');
          if (event.url.includes('contact')) {
            this.routeNo = 1;
            this.currentRoute ='Contact'  
            this.ariaText= this.routeNo +" of 6 steps to request a clinic";                 
            this.myInputt.nativeElement.focus();
          } else if (event.url.includes('organisation')) {
            this.routeNo = 2;
             this.currentRoute ='Organization'
             this.ariaText= this.routeNo +" of 6 steps to request a clinic";
             this.myInputt.nativeElement.focus();
          } else if (event.url.includes('services')) {
            this.routeNo = 3;
            this.currentRoute ='Services'
            this.ariaText= this.routeNo +" of 6 steps to request a clinic";
            this.myInputt.nativeElement.focus();
          } else if (event.url.includes('clinic-details')) {
            this.routeNo = 4;
            this.currentRoute ='Clinic Details'
            this.ariaText= this.routeNo +" of 6 steps to request a clinic";
            this.myInputt.nativeElement.focus();
          } else if (event.url.includes('billing')) {
            this.routeNo = 5;
            this.currentRoute ='Coverage Options'
            this.ariaText= this.routeNo +" of 6 steps to request a clinic";
            this.myInputt.nativeElement.focus();
          } else if (event.url.includes('review-details')) {
            this.routeNo = 6;
            this.currentRoute ='Review and Submit'
            this.ariaText= this.routeNo +" of 6 steps to request a clinic";
            this.myInputt.nativeElement.focus();
          }
        }
        
        
      });


    }
   
    
    
 
  }

  enableFocusHeader(url:any){
    if (url.includes('contact')) {
      this.routeNo = 1;
      this.currentRoute ='Contact'  
      this.ariaText= this.routeNo +" of 6 steps to request a clinic";                 
      this.myInputt.nativeElement.focus();
    } else if (url.includes('organisation')) {
      this.routeNo = 2;
       this.currentRoute ='Organization'
       this.ariaText= this.routeNo +" of 6 steps to request a clinic";
       this.myInputt.nativeElement.focus();
    } else if (url.includes('services')) {
      this.routeNo = 3;
      this.currentRoute ='Services'
      this.ariaText= this.routeNo +" of 6 steps to request a clinic";
      this.myInputt.nativeElement.focus();
    } else if (url.includes('clinic-details')) {
      this.routeNo = 4;
      this.currentRoute ='Clinic Details'
      this.ariaText= this.routeNo +" of 6 steps to request a clinic";
      this.myInputt.nativeElement.focus();
    } else if (url.includes('billing')) {
      this.routeNo = 5;
      this.currentRoute ='Coverage Options'
      this.ariaText= this.routeNo +" of 6 steps to request a clinic";
      this.myInputt.nativeElement.focus();
    } else if (url.includes('review-details')) {
      this.routeNo = 6;
      this.currentRoute ='Review and Submit'
      this.ariaText= this.routeNo +" of 6 steps to request a clinic";
      this.myInputt.nativeElement.focus();
    }
}
}



